import { Sun, Moon } from 'lucide-react';
import { useStore } from '@/store';
import { selectTheme } from '@/store/selectors';
import type { AppSettings } from '@/types/persistence';

export function ThemeToggle() {
  const resolved = useStore(selectTheme);
  const setTheme = useStore((s) => s.setTheme);

  const next: AppSettings['theme'] = resolved === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(next)}
      title={`Currently ${resolved} mode — click to switch to ${next}`}
      aria-label={`Switch to ${next} theme`}
    >
      <span aria-hidden="true">{resolved === 'dark' ? <Sun size={16} /> : <Moon size={16} />}</span>
    </button>
  );
}
